import { render, staticRenderFns } from "./VersionHint.vue?vue&type=template&id=05f103c2&scoped=true"
import script from "./VersionHint.vue?vue&type=script&lang=js"
export * from "./VersionHint.vue?vue&type=script&lang=js"
import style0 from "./VersionHint.vue?vue&type=style&index=0&id=05f103c2&prod&lang=less&scoped=true"
import style1 from "./VersionHint.vue?vue&type=style&index=1&id=05f103c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f103c2",
  null
  
)

export default component.exports